import React, { useEffect } from 'react';
import HourGlass from 'assets/images/hour-glass.png';
import { ReactComponent as HelpIcon } from 'assets/icons/help-icon.svg';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import useAxios from 'hooks/useAxios';
import { useNavigate } from 'react-router-dom';
import { CompaniesListType } from 'models/company.model';

const VerificationPending = () => {
  const verificationEmail = localStorage.getItem(STORAGE_KEYS.NEW_USER_EMAIL);
  const navigate = useNavigate();
  const { fetchData, response } = useAxios<{ data: { data: CompaniesListType[] } }>({
    url: 'company'
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (response?.data?.data?.some((company) => company.verified)) {
      navigate(ROUTE_KEYS.GET_STARTED);
    }
  }, [response]);

  return (
    <div className='w-full h-[100vh] flex flex-col p-4'>
      <div className='w-full h-[82px] border-b border-b-[#EFF0F0] px-3 md:px-[50px] py-[26px]'>
        <div className='flex gap-3 items-center'>
          <div className='w-[30px] h-[30px] rounded-full bg-[#F4F1F1] flex justify-center items-center'>
            <div className='w-[18px] h-[18px] rounded-full p-[2px] border border-[#E60A2B] flex justify-center items-center'>
              <HelpIcon />
            </div>
          </div>
          <p className='text-[#2E3031] text-sm'>
            Need Help ? <span className='text-[#5E6164]'>contact us</span>
          </p>
        </div>
      </div>
      <div className='flex flex-col items-center justify-center space-y-4 w-full h-[80vh]'>
        <div className='bg-[#0080E5] rounded-full w-[140px] h-[140px] flex items-center justify-center'>
          <img src={HourGlass} alt='' className='w-[80px] h-[80px]' />
        </div>
        <h2 className='text-xl font-semibold '>Verification Pending</h2>
        <div className='w-full sm:w-[80%] md:w-[70%] lg:w-[60%]'>
          <p className=' text-[#6F7376] text-center'>
            We will notify you via {verificationEmail} once your company details has been verified
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationPending;
